// import { Chromecast } from "@caprockapps/capacitor-chromecast";
import React, { useState } from "react";
import { IonFab, IonFabButton, IonIcon } from "@ionic/react";
import { connect } from "react-redux";
import ChromeCastIcon from "components/ChromeCastIcon";
import Spacer from "components/spacer";
import ChromeCast from "services/chromecast";
import JumpTo from "components/JumpToModal";
import { searchOutline, musicalNote } from "ionicons/icons";

import { WSemit } from "services/socket";
import { toggleMusic } from "services/general/actions";
import { setLoading } from "services/loading";
import { syncQuizConfig, updateProgress } from "services/quiz";

interface props {
  user: any;
  quizData: any;
  teams: any;
  toggleMusic: Function;
  syncQuizConfig: Function;
  setLoading: Function;
  ccConnected: boolean;
  updateProgress: Function;
  musicActive: number;
  playlist: any;
  playlistPosition: number;
}

const ChromeCastButtons: React.FC<props> = ({
  user,
  quizData,
  // teams,
  // toggleMusic,
  syncQuizConfig,
  setLoading,
  // ccConnected,
  updateProgress,
  musicActive,
  playlist,
  playlistPosition,
}) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { customerId, quizId } = quizData.progress;

  const requestSession = () => {
    ChromeCast.connect({ user, quizData });
    if (!ChromeCast.isConnected) {
      setLoading(true, "Syncing quiz config...");
      syncQuizConfig(quizData.quizId).then(() => setLoading(false));
    }
  };

  const setNextSong = () => {
    const newPosition =
      playlistPosition >= playlist.length ? 1 : playlistPosition + 1;
    WSemit("nextSong", {
      playlistPosition: newPosition,
      progressId: quizData.progress.progressId,
      customerId,
      quizId,
    });
  };

  const handleMusicChange = () => {
    const newStatus = musicActive === 0 ? 1 : 0;
    WSemit("updateMusicActive", {
      musicActive: newStatus,
      progressId: quizData.progress.progressId,
      quizId,
      customerId,
    });
    if (musicActive === 0) {
      setNextSong();
    }
    //updateProgress({ musicActive: newStatus });
  };

  return (
    <>
      {quizData.quizId !== 0 &&
        (user.userDetails.availableQuizId === quizData.quizId ||
          quizData.quizId > user.userDetails.availableQuizId) && (
          <>
            <JumpTo modalOpen={modalOpen} setModalOpen={setModalOpen} />
            <IonFab slot="fixed" vertical="bottom" horizontal="end">
              <IonFabButton onClick={requestSession} color="danger">
                <ChromeCastIcon />
              </IonFabButton>
              {/* {ccConnected && ( */}
              <>
                <Spacer size="15" />
                <IonFabButton
                  onClick={() => handleMusicChange()}
                  style={{ opacity: `${musicActive === 1 ? 1 : 0.4}` }}
                >
                  <IonIcon color="light" icon={musicalNote} size="large" />
                </IonFabButton>
                <Spacer size="15" />
                <IonFabButton onClick={() => setModalOpen(true)}>
                  <IonIcon icon={searchOutline} size="large" />
                </IonFabButton>
              </>
              {/* )} */}
            </IonFab>
          </>
        )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user,
  quizData: state.quiz,
  teams: state.teams.teams,
  musicActive: state.quiz.progress.musicActive,
  ccConnected: state.general.ccConnected,
  playlist: state.user.userDetails.songPlaylist,
  playlistPosition: state.quiz.progress.playlistPosition,
});

export default connect(mapStateToProps, {
  toggleMusic,
  syncQuizConfig,
  setLoading,
  updateProgress,
})(ChromeCastButtons);
